import { FC, ComponentProps, useState } from "react";
import { toast } from "react-toastify";

import Button from "../Button";
import MemberDetails from "../../pages/Members/MemberDetails";
import { fetchMemberDetailsUser } from "../../services/api/admin/user";
import { UserAdminResult } from "../../types/User";

interface Props {
    userId: string;
    size?: ComponentProps<typeof Button>["size"];
    variant?: ComponentProps<typeof Button>["variant"];
    label?: string;
    className?: string;
}

const MemberInfoModalButton: FC<Props> = ({
    userId,
    size = "newSmall",
    variant = "primary_outlined",
    label = "Voir les infos",
    className,
}) => {
    const [open, setOpen] = useState(false);
    const [user, setUser] = useState<UserAdminResult | undefined>();

    const handleOpen = async () => {
        setOpen(true);
        setUser(undefined);

        try {
            const member = await fetchMemberDetailsUser(userId);
            if (!member) {
                toast.error("Impossible de charger les informations du membre.");
                setOpen(false);
                return;
            }
            setUser(member);
        } catch {
            toast.error("Impossible de charger les informations du membre.");
            setOpen(false);
        }
    };

    return (
        <>
            <Button
                size={size}
                variant={variant}
                className={className}
                onClick={() => {
                    void handleOpen();
                }}
            >
                {label}
            </Button>
            <MemberDetails
                open={open}
                handleClose={() => {
                    setOpen(false);
                    setUser(undefined);
                }}
                user={user}
            />
        </>
    );
};

export default MemberInfoModalButton;
